/* eslint-disable @typescript-eslint/no-explicit-any */
import { createContext } from 'react';

export type ErrorHandlerProps= {
  close: () => void
  open: (error: any) => void
  isOpen: boolean
  error: any
}
export const ErrorHandlerContext = createContext<ErrorHandlerProps | null>(null)